// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoonIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Moon/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.354 15.354.928.373a1 1 0 0 0-1.3-1.3l.372.927ZM8.646 3.646l.928.373a1 1 0 0 0-1.301-1.301l.373.928Zm11.335 10.78c-.92.37-1.925.574-2.981.574v2a9.976 9.976 0 0 0 3.727-.718l-.746-1.856ZM17 15a8 8 0 0 1-8-8H7c0 5.523 4.477 10 10 10v-2ZM9 7c0-1.056.204-2.061.574-2.981l-1.856-.746A9.975 9.975 0 0 0 7 7h2Zm-5 5a8.003 8.003 0 0 1 5.019-7.426l-.746-1.856A10.003 10.003 0 0 0 2 12h2Zm8 8a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-2Zm7.426-5.019A8.003 8.003 0 0 1 12 20.001v2c4.207 0 7.805-2.599 9.282-6.274l-1.856-.746Z"
}));
export default MoonIcon;